


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { types } from '../../api_types';
import T from '../../lang';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBell, faAlignRight } from '@fortawesome/free-solid-svg-icons';
library.add(faBell, faAlignRight);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class Clarifications extends Vue {
  @Prop({ default: () => [] }) clarifications!: types.Clarification[];

  @Prop() isAdmin!: boolean;
  T = T;

  flashInterval: number = 0;
  unreadClarifications = this.clarifications;

  @Watch('clarifications')
  onPropertyChanged(newValue: types.Clarification[]): void {
    this.unreadClarifications = newValue;
    const audio = this.$refs['notification-audio'] as HTMLMediaElement;
    if (!audio) return;
    audio.play();
  }

  @Watch('unreadClarifications')
  onPropertyChange(newValue: types.Clarification[]): void {
    if (newValue.length > 0) {
      if (this.flashInterval) return;
      this.flashInterval = setInterval(this.flashTitle, 1000);
    } else {
      if (!this.flashInterval) return;
      clearInterval(this.flashInterval);
      this.flashInterval = 0;
      if (document.title.indexOf('!') === 0) {
        document.title = document.title.substring(2);
      }
    }
  }

  anchor(clarification: types.Clarification): string {
    return `#clarifications/clarification-${clarification.clarification_id}`;
  }

  flashTitle(reset: boolean): void {
    if (document.title.indexOf('!') === 0) {
      document.title = document.title.substring(2);
    } else if (!reset) {
      document.title = `! ${document.title}`;
    }
  }

  onCloseClicked(clarification: types.Clarification): void {
    const id = `clarification-${clarification.clarification_id}`;
    this.unreadClarifications = this.unreadClarifications.filter(
      (element) => element.clarification_id !== clarification.clarification_id,
    );
    localStorage.setItem(id, Date.now().toString());
  }

  onMarkAllAsRead(): void {
    for (const clarification of this.unreadClarifications) {
      const id = `clarification-${clarification.clarification_id}`;
      localStorage.setItem(id, Date.now().toString());
    }
    this.unreadClarifications = [];
  }
}
